import { render } from "./Feedback.vue?vue&type=template&id=29b31682&scoped=true&ts=true"
import script from "./Feedback.vue?vue&type=script&lang=ts"
export * from "./Feedback.vue?vue&type=script&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=29b31682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b31682"]])

export default __exports__